import { GridProps, SxProps } from '@mui/material';
import { defaultContainerStyling, listPageTableWrapperStyles } from '../../styles/sxStyling';

export const ROW_HEIGHT = 24;
export const borderStyle = '1px solid var(--border-color)';

export const contentContainerProps: GridProps = {
  container: true,
  size: 7,
  columns: 7,
  sx: { py: 1 },
};

export const headerSx: SxProps = {
  textAlign: 'center',
  borderBottom: '2px solid var(--border-color)',
  '.MuiTypography-root': { fontWeight: 'bold' },
};

export const employeeHeaderSx: SxProps = {
  ...headerSx,
  minHeight: ROW_HEIGHT * 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRight: borderStyle,
};

export const eventHeaderSx: SxProps = {
  height: ROW_HEIGHT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderBottom: borderStyle,
  width: '100%',
};

export const dateCellSx: SxProps = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderLeft: borderStyle,
};

export const calendarWrapperSx: SxProps = {
  ...listPageTableWrapperStyles,
  ...defaultContainerStyling,
  overflow: 'hidden',
  border: borderStyle,
  bgcolor: 'background.paper',
};
